import type { loginSchemaOutput } from "@/api/custom_types";
import { atomWithStorage, createJSONStorage } from "jotai/utils";

export const USER_LOGGED_IN_KEY = "FCLoggedInUser" as const;

export const currentUserAtom = atomWithStorage<loginSchemaOutput | null>(
	USER_LOGGED_IN_KEY,
	null,
	createJSONStorage(() => localStorage),
	{ getOnInit: true },
);
currentUserAtom.debugLabel = "currentUserAtom";
